<app-widgets />

<div class="row">
    <app-produced-energy [produced]="143" [shared]="86" [type]="'history'" class="col-lg-4" />
    <app-consumed-energy [consumed]="218" [shared]="86" [type]="'history'" class="col-lg-4" />
    <app-score [score]="40" class="col-lg-4" />
</div>

<div class="row">
    <!-- Consumo e produzione giornalieri -->
    <div class="cardWithShadow col-lg-12">
        <app-consumi />
    </div>
</div>

<!-- Picchi -->
<div>
    <app-peaks />
</div>